import { configureStore } from "@reduxjs/toolkit";
import navigatorReducer from "./navigator";
import snackbarReducer from "./snackbar";
import queueReducer from "./queue";
import videoReducer from "./videos";
const AppStore = configureStore({
  reducer: {
    navigator: navigatorReducer,
    snackbar: snackbarReducer,
    queue: queueReducer,
    videos: videoReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export default AppStore;
